import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { HelmetProvider } from 'react-helmet-async';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: 'production',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <HelmetProvider>
      <BrowserRouter>
        {' '}
        {/* ✅ Router로 감싸야 navigate가 작동 */}
        <App />
        <ReactQueryDevtools initialIsOpen={false} />
      </BrowserRouter>
    </HelmetProvider>
  </QueryClientProvider>,
);
